import Link from 'next/link';
import { ChevronRightIcon } from '@c/icons';

export type BreadcrumbItem = {
  label: string;
  href: string;
  current?: boolean;
  currentCss?: string;
};

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  color?: string;
}

const Breadcrumb = ({
  items,
  color = 'text-brand-secondary',
}: BreadcrumbProps) => {
  return (
    <nav aria-label="Breadcrumb">
      <div className="flex flex-wrap items-center font-medium sm:gap-[0.2rem]">
        {items.map((item, i) => (
          <div
            key={`breadcrumb-${i}`}
            className="flex items-center"
          >
            {item.current ? (
              <p className={item.currentCss}>{item.label}</p> //don't use link for current
            ) : (
              <Link className={color} href={item.href} title={`Browse New & Used ${item.label==='Home' ? 'Camera Equipment' : item.label}`}>
                {item.label}
              </Link>
            )}
            {i < items.length - 1 && <ChevronRightIcon height={14} />}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;
